import React, { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { Bell, CheckCheck } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { formatDate } from "@/lib/format";

export function NotificationBell() {
  const qc = useQueryClient();
  const [open, setOpen] = useState(false);
  const { data } = useQuery({
    queryKey: ["notifications"],
    queryFn: async () => (await api.get("/notifications")).data,
    refetchInterval: 20000,
  });
  const unread = data?.unread || 0;
  const items = data?.notifications || [];

  const markAll = async () => {
    await api.post("/notifications/read-all");
    qc.invalidateQueries({ queryKey: ["notifications"] });
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button data-testid="notification-bell" className="relative p-2 rounded-xl hover:bg-[#EAF3EF] transition-colors">
          <Bell className="h-5 w-5 text-[#102A2A]" />
          {unread > 0 && (
            <span data-testid="notification-count" className="absolute -top-0.5 -right-0.5 h-5 min-w-5 px-1 rounded-full bg-[#C0392B] text-white text-[10px] font-bold flex items-center justify-center">
              {unread}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0 bg-white border border-[#D2E3DB] rounded-xl shadow-lg">
        <div className="flex items-center justify-between px-4 py-3 border-b border-[#D2E3DB]">
          <span className="font-bold text-[#102A2A]">Notifiche</span>
          {unread > 0 && (
            <button onClick={markAll} data-testid="mark-all-read" className="text-xs font-semibold text-[#087A73] flex items-center gap-1">
              <CheckCheck className="h-4 w-4" /> Segna lette
            </button>
          )}
        </div>
        <div className="max-h-80 overflow-y-auto">
          {items.length === 0 ? (
            <p className="px-4 py-8 text-center text-sm text-[#5C6B68]">Nessuna notifica.</p>
          ) : (
            items.slice(0, 15).map((n) => (
              <div key={n.id} className={`px-4 py-3 border-b border-[#EAF3EF] ${!n.read_at ? "bg-[#EAF3EF]/50" : ""}`}>
                <p className="text-sm font-semibold text-[#102A2A]">{n.title}</p>
                <p className="text-xs text-[#5C6B68] mt-0.5">{n.message}</p>
                <p className="text-[10px] text-[#5C6B68]/60 mt-1">{formatDate(n.created_at)}</p>
              </div>
            ))
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
}
